export default function AboutUs() {
  return (
    <section id="about" className="py-20 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Sobre Nosotros</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Somos una escuela infantil privada en Madrid, especializada en el primer ciclo de educación infantil (0-3 años), ubicada en San Blas.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Ofrecemos un espacio cálido y seguro donde cada niño desarrolla habilidades fundamentales, explora con curiosidad, aprende con alegría y se siente acompañado en cada paso.
            </p>
            <div className="inline-flex items-center bg-[#A8C5B0] text-white px-6 py-3 rounded-full">
              <i className="ri-shield-check-line text-xl mr-2"></i>
              <span className="font-medium">Centro homologado por la Comunidad de Madrid</span>
            </div>
          </div>
          <div className="relative flex justify-center">
            <div className="rounded-3xl overflow-hidden shadow-2xl max-w-xs">
              <img
                src="https://static.readdy.ai/image/dd95bba129a4e648d9c1ab0ceae0e9b1/0dc98ac3048557a1f2a8c27e8d204195.jpeg"
                alt="Ambiente acogedor de nuestra escuela"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
